import { useEffect, useRef } from 'react'

export default function PageCommandContextMenu({
  menu,
  onClose,
  onAddToIdeas,
  onRemoveFromIdeas,
}) {
  const menuRef = useRef(null)
  useEffect(() => {
    if (!menu) return undefined
    const closeOnPointerDown = (event) => {
      if (!menuRef.current?.contains(event.target)) onClose()
    }
    const closeOnKeyDown = (event) => {
      if (event.key === 'Escape') onClose()
    }
    document.addEventListener('pointerdown', closeOnPointerDown)
    document.addEventListener('keydown', closeOnKeyDown)
    menuRef.current?.focus()
    return () => {
      document.removeEventListener('pointerdown', closeOnPointerDown)
      document.removeEventListener('keydown', closeOnKeyDown)
    }
  }, [menu, onClose])

  if (!menu?.assetSymbol || !(onAddToIdeas || onRemoveFromIdeas)) return null

  return (
    <div
      ref={menuRef}
      role="menu"
      aria-label={`${menu.assetSymbol} actions`}
      tabIndex={-1}
      data-command-shield="true"
      className="fixed z-[1250] w-56 overflow-hidden rounded-lg border border-border bg-canvas p-1.5 text-ink shadow-2xl outline-none"
      style={{
        left: `min(${Math.max(8, menu.x)}px, calc(100vw - 14rem - 8px))`,
        top: `min(${Math.max(8, menu.y)}px, calc(100vh - 3rem - 8px))`,
      }}
    >
      <button type="button" role="menuitem" onClick={() => { void (onRemoveFromIdeas || onAddToIdeas)(menu.assetSymbol); onClose() }} className="w-full rounded-md px-2.5 py-2 text-left text-xs font-semibold text-ink hover:bg-canvas2">
        {onRemoveFromIdeas ? 'Remove from Ideas List' : 'Add asset to Ideas List'}
      </button>
    </div>
  )
}
